import React, { useState } from 'react';
import { Form, Button, Container, Card, Row, Col, InputGroup } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { AddSubscriberApi } from '../../Services/Subscriber';
import { toast } from 'react-toastify';
import { FaUser, FaMobileAlt, FaPhone, FaEnvelope, FaGlobe, FaMapMarkerAlt, FaBuilding, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';

const SubscriptionForm = () => {
    const [formData, setFormData] = useState({
        Name: '',
        Mobile: '',
        Phone: '',
        Email: '',
        Website: '',
        Address: '',
        CompanyName: '',
        SubscrPlanId: '',
        Source: ''
    });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const { mutate, isLoading } = useMutation(AddSubscriberApi, {
        onSuccess: (data) => {
            if (data.ResponseCode === 200) {
                toast.success(data?.ResponseMessage);
                setSubmitted(true);
            } else {
                toast.warn(data?.ResponseMessage);
            }
        },
        onError: (error) => {
            console.error(error);
            toast.error("Failed to subscribe.");
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const validateForm = () => {
        let formErrors = {};
        if (!formData.Name) formErrors.Name = "Name is required";
        if (!formData.Mobile) {
            formErrors.Mobile = "Mobile number is required";
        } else if (!/^\d+$/.test(formData.Mobile)) {
            formErrors.Mobile = "Mobile number should contain only digits";
        }
        if (!formData.Email) {
            formErrors.Email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email)) {
            formErrors.Email = "Invalid email format";
        }
        if (formData.Phone && !/^\d+$/.test(formData.Phone)) {
            formErrors.Phone = "Phone number should contain only digits";
        }
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            mutate(formData);
        }
    };

    return (
        <Container>
            <Card className="shadow-lg p-4">
                <Card.Body>
                    <Card.Title className="text-center mb-4 display-6">
                        {submitted ? "Thank You!" : "Subscription Form"}
                    </Card.Title>
                    
                    {submitted ? (
                        
                        <div className="text-center">
                            <FaCheckCircle size={80} color="green" />
                            <h4 className="mt-3">Thank you for submitting!</h4>
                        </div>
                    ) : (
                       
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="name" className="mb-3">
                                        <Form.Label>Name</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaUser /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter name"
                                                name="Name"
                                                value={formData.Name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.Name}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Name}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="mobile" className="mb-3">
                                        <Form.Label>Mobile</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaMobileAlt /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter mobile number"
                                                name="Mobile"
                                                value={formData.Mobile}
                                                onChange={handleChange}
                                                isInvalid={!!errors.Mobile}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Mobile}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="phone" className="mb-3">
                                        <Form.Label>Phone</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaPhone /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter phone number"
                                                name="Phone"
                                                value={formData.Phone}
                                                onChange={handleChange}
                                                isInvalid={!!errors.Phone}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Phone}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="email" className="mb-3">
                                        <Form.Label>Email</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaEnvelope /></InputGroup.Text>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter email"
                                                name="Email"
                                                value={formData.Email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.Email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.Email}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="website" className="mb-3">
                                        <Form.Label>Website</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaGlobe /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter website"
                                                name="Website"
                                                value={formData.Website}
                                                onChange={handleChange}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="company" className="mb-3">
                                        <Form.Label>Company</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaBuilding /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter company"
                                                name="CompanyName"
                                                value={formData.CompanyName}
                                                onChange={handleChange}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Form.Group controlId="address" className="mb-3">
                                        <Form.Label>Address</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FaMapMarkerAlt /></InputGroup.Text>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter address"
                                                name="Address"
                                                value={formData.Address}
                                                onChange={handleChange}
                                            />
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-end mt-2">
                                <Button variant="danger" type="submit" disabled={isLoading} style={{ width: '130px' }}>
                                    {isLoading ? (
                                        <>Subscribing...</>
                                    ) : (
                                        <>
                                            <FaPaperPlane className="me-2" />
                                            Subscribe
                                        </>
                                    )}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default SubscriptionForm;
